export default () => ({
  init() {
    this.store = Alpine.store("data")
  },

  handleDiscountButtonClick({ scrollAnchorId }) {
    this.store.internalTracker.trackClick({ clickName: "Anchor 1 Clicked" })

    const id = scrollAnchorId || "selectPlanTitle"
    document.getElementById(id).scrollIntoView({ behavior: "smooth", block: 'center' })
  },
})
